(function () {
	/* Toggle content */
	$('.product-description-more').click(function (e) {
		e.preventDefault();
		$(this).closest('.product-description-short').next().show();
		$(this).closest('.product-description-short').hide();
	});

	$('.product-description-less').click(function (e) {
		e.preventDefault();
		$(this).closest('.product-description-full').prev().show();
		$(this).closest('.product-description-full').hide();
	});

	/* Toggle fields */
	$('.js-show-more').click(function (e) {
		e.preventDefault();
		$(this).siblings('input').removeClass('hidden');
		$(this).siblings('label').removeClass('hidden');
		$(this).remove();
	});
})();

/* Second floated product form */
class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute('data-product-url'))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
				this.productElement = responseHTML.querySelector('div[id^="ProductInfo-"]');

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll('script').forEach(oldScriptTag => {
			const newScriptTag = document.createElement('script');
			Array.from(oldScriptTag.attributes).forEach(attribute => {
				newScriptTag.setAttribute(attribute.name, attribute.value)
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `floated-${ sectionId }`);

		if (this.productElement.querySelectorAll('variant-selects')) {
			this.productElement.querySelectorAll('variant-selects').forEach(radio => {
				radio.dataset.originalSection = sectionId;
			});
		}

		if (this.productElement.querySelectorAll('variant-radios')) {
			this.productElement.querySelectorAll('variant-radios').forEach(radio => {
				radio.dataset.originalSection = sectionId;
			});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector('.product__text');
		if (text) text.remove();

		const shareButtons = this.productElement.querySelector('.share-buttons');
		if (shareButtons) shareButtons.remove();

		const rating = this.productElement.querySelector('.rating');
		if (rating) rating.remove();

		const tags = this.productElement.querySelector('.product-tags');
		if (tags) tags.remove();

		const description = this.productElement.querySelector('.product__description');
		if (description) description.remove();

		const advantages = this.productElement.querySelectorAll('.advantage');
		advantages.forEach(advantage => {
			advantage.remove();
		});

		const note = this.productElement.querySelector('.note');
		if (note) note.remove();

		const promoBanner = this.productElement.querySelector('.promo-banner');
		if (promoBanner) promoBanner.remove();

		const pickupAvailability = this.productElement.querySelector('pickup-availability');
		if (pickupAvailability) pickupAvailability.remove();

		const productModal = this.productElement.querySelector('product-modal');
		if (productModal) productModal.remove();

		const productForm = this.productElement.querySelector('floated-form');
		if (productForm) productForm.remove();

		const relatedProduct = this.productElement.querySelector('related-product');
		if (relatedProduct) relatedProduct.remove();

		const gift = this.productElement.querySelector('.customer');
		if (gift) gift.remove();

		const customLiquid = this.productElement.querySelector('.custom-liquid');
		if (customLiquid) customLiquid.remove();
	}

	showMoreFields() {
		$('.js-show-more').click(function (e) {
			e.preventDefault();
			$(this).siblings('input').removeClass('hidden');
			$(this).siblings('label').removeClass('hidden');
			$(this).remove();
		});
	}
}

customElements.define('floated-form', FloatedForm);


// Dropdown Info Blocks

document.addEventListener('DOMContentLoaded', function () {
		
	window.dropdownsInitialized = true;
	
	// Open first two dropdowns by default
	document.querySelectorAll('.js-info-dropdown').forEach(function(dropdown, index) {
	  if (index < 1) {
		const header = dropdown.querySelector('.info-dropdown__header');
		const content = dropdown.querySelector('.info-dropdown__content');
		
		if (header && content) {
		  header.setAttribute('aria-expanded', 'true');
		  content.removeAttribute('hidden');
		}
	  }
	});
	
	document.body.addEventListener('click', function(e) {
	  
	  const header = e.target.closest('.info-dropdown__header');
	  if (!header) return;
	  
	  const dropdown = header.closest('.js-info-dropdown');
	  if (!dropdown) return;
	  
	  const content = dropdown.querySelector('.info-dropdown__content');
	  if (!content) return;
	  
	  e.stopPropagation();
	  e.preventDefault();
	  
	  document.querySelectorAll('.js-info-dropdown').forEach(function(otherDropdown) {
		if (otherDropdown !== dropdown) {
		  otherDropdown.querySelector('.info-dropdown__content').setAttribute('hidden', '');
		  otherDropdown.querySelector('.info-dropdown__header').setAttribute('aria-expanded', 'false');
		}
	  });
	  
	  const isExpanded = header.getAttribute('aria-expanded') === 'true';
	  header.setAttribute('aria-expanded', !isExpanded);
	  
	  if (isExpanded) {
		content.setAttribute('hidden', '');
	  } else {
		content.removeAttribute('hidden');
	  }
	});
	
	//console.log('Global dropdown handler initialized');
  });